import { createSlice } from "@reduxjs/toolkit";
import { toGetPartners } from "../actions/partners.actions";

const initialState = {
  partners: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const partnersSlice = createSlice({
  name: "partners",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetPartners.pending, (state) => {
      state.partners = { list: [], status: "idle" };
    });
    builder.addCase(toGetPartners.fulfilled, (state, action) => {
      state.partners = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetPartners.rejected, (state, action) => {
      state.partners = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default partnersSlice.reducer;
